import { useMemo } from 'react'

type Flag = {
  name: string
  description: string
  active: boolean
}

export const initFeatures = () => {
  const defaultFlags: Flag[] = [
    {
      name: 'fake-response',
      description: 'Fake response',
      active: false,
    },
    {
      name: 'disable-trends-build',
      description: 'Disables trends build for dev purposes',
      active: false,
    },
  ]

  const flags = localStorage.getItem('jelled_flags')

  if (!flags) {
    localStorage.setItem('jelled_flags', JSON.stringify(defaultFlags))
  } else {
    const parsedFlags = JSON.parse(flags)
    const parsedFlagNames = parsedFlags.map((flag: Flag) => flag.name)

    const updatedFlags = [...parsedFlags]
    defaultFlags.forEach((flag) => {
      if (!parsedFlagNames.includes(flag.name)) {
        updatedFlags.push(flag)
      }
    })

    localStorage.setItem('jelled_flags', JSON.stringify(updatedFlags))
  }
}

function useFlag(name: string) {
  const feature = useMemo(() => {
    // we should force a refresh if localStorage.getItem('jelled_flags') is null
    if (!localStorage.getItem('jelled_flags')) {
      window.location.reload()
    }

    const features = JSON.parse(localStorage.getItem('jelled_flags') || '')
    const feature = features.find((feature: Flag) => feature.name === name)
    return feature
  }, [name])

  return {
    feature,
  }
}

export default useFlag
